module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("To assist you in your choice of route we have provided a summary of all twelve routes in the guidebook together with an indication as to their suitability for walkers, cyclists or car tourists. Distances are in km – the first figure in the table – and miles. You will find that the circular alpha/numeric references in the text of each route correspond directly with those on the relevant map.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d918f3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/37_fm045.vue
// module id = 168
// module chunks = 0